export const RECORD_TYPE = 'assessment';
export const RECORD_SUBTYPE = 'diagnosis';
export const UPDATE_FIELDS = [
  'icd10',
  'diagnosis',
  'text',
  'recommendedProcedures',
];